import React from "react";
import PropTypes from "prop-types";

export function TokenProvider({ children }) {
  return <>{children}</>;
}

TokenProvider.propTypes = {
  children: PropTypes.node
};
